/**
 * @doc
 * Global object for sharing functional helpers
 * This can be used in any file. Like user's login info will be stored in This
 * global
 */

const app = {
  locale: "en",
  config: {
    API_URL: "",
  },
  user: {},
  companies: [],
};

export default app;
